import React, { useState } from 'react'

import moment from 'moment'

import { useSelector, useDispatch } from 'react-redux'

import { withRouter } from 'react-router-dom'

import SourceIcon from '../tools/SourceIcon'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'

import Button from '@material-ui/core/Button'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Avatar from '@material-ui/core/Avatar'

import { withStyles, makeStyles } from '@material-ui/core/styles'

import FlagIcon from '@material-ui/icons/Flag'

import { truncateText } from '../../../utils'
import { QuarantineSubBanner } from '../tools'

import { setFromView } from '../../../redux/actions'

import queryString from 'query-string'

import { toggleImage } from '../../../utils/functions/toggleFunctions'

const getSeverityColor = (severity) => {
  if (severity > 0 && severity <= 20) {
    return '#5291fc'
  } else if (severity > 20 && severity <= 40) {
    return '#4e179a'
  } else if (severity > 40 && severity <= 60) {
    return '#f5d818'
  } else if (severity > 60 && severity <= 80) {
    return '#e7840f'
  } else {
    return '#d31111'
  }
}

const useStyles = makeStyles((theme) => ({
  listImg: {
    width: '100%',
    // paddingTop: '100%',
    height: '100%',
    margin: 'auto 0',
    backgroundSize: 'contain'
  },
  violationCard: {
    width: '100%',
    backgroundColor: '#d8e4f2'
  },
  newCapture: {
    borderBottom: '10px solid #CB9BFF'
  },
  problemCapture: {
    borderBottom: '10px solid #FFA593'
  },
  noProblemCapture: {
    borderBottom: '10px solid #96E1A8'
  },
  holdCapture: {
    borderBottom: '10px solid #FFFF91'
  },
  solvedCapture: {
    borderBottom: '10px solid #A6FFFF'
  },
  changedCapture: {
    borderBottom: '10px solid #ffa500'
  },
  violationContainer: {
    height: 'auto'
  },
  imageContainer: {
    // height: '100%'
  },
  infoContainer: {
    height: '100%'
  },
  activeArrow: {
    borderTop: '3.125em solid transparent',
    borderBottom: '3.125em solid transparent',
    borderLeft: '2.5em solid #4b4f58',
    position: 'fixed',
    zIndex: 1
  },
  violationOverlay: {
    position: 'absolute',
    width: '61.5%',
    height: '31%'
  },
  hoveredImage: {
    border: '#77818f 3px solid',
    borderRadius: '1em'
  },
  mediaBase: {
    width: '100%'
  },
  flagContainer: {
    position: 'absolute',
    height: 'auto',
    width: 'auto',
    zIndex: 1,
    pointerEvents: 'none'
  },
  flagAvatar: {
    backgroundColor: theme.palette.error.light
  }
}))

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 12,
    leavTouchDelay: 10000
  }
}))(Tooltip)

const ListView = (props) => {
  const { capture, handleQuickFilter, getSourceDescription } = props
  const classes = useStyles()
  const dispatch = useDispatch()

  const parsedProps = queryString.parse(props.location.search)
  const Captures = useSelector(state => state.violations.violations.captures)
  const PageLimit = useSelector(state => state.selection.PageCaptureLimit)
  const MatchPage = parseInt(parsedProps.page)

  const [hovered, setHovered] = useState(false)

  // uses pagination settings to calculate the correct number of the violation to redirect to
  const calculateCaptureNumber = (index) => {
    if (!index || isNaN(parseInt(index))) { return 0 }
    return index + (parseInt(PageLimit, 10) * (MatchPage - 1))
  }

  const handleClick = () => {
    const CaptureIndex = Captures.findIndex((violations) => {
      return violations.violationID === capture.violationID
    }) + 1
    dispatch(setFromView('list'))

    props.history.push({
      pathname: '/captures',
      search: `?view=single&capture=${calculateCaptureNumber(CaptureIndex)}`
    })
  }

  const iconOptions = {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 18,
    leaveTouchDelay: 10000
  }

  const getCardFlag = (text) => {
    switch (text) {
      case 'U':
        return classes.newCapture
      case 'P':
        return classes.problemCapture
      case 'N':
        return classes.noProblemCapture
      case 'H':
        return classes.holdCapture
      case 'S':
        return classes.solvedCapture
      case 'C':
        return classes.changedCapture
      default:
        return ''
    }
  }
  return (
    <>
      {capture.isFlagged &&
        <Grid container direction='row' className={classes.flagContainer}>
          <Avatar variant='rounded' className={classes.flagAvatar}>
            <FlagIcon />
          </Avatar>
        </Grid>}
      {capture &&
        <Card className={`${getCardFlag(capture.statusFlag)} ${classes.violationCard} d-flex`} raised>
          <Grid container direction='row' className={classes.violationContainer}>
            <Grid container direction='row' style={{ position: 'absolute', marginTop: '4em' }}>
              <div className={`${classes.activeArrow} my-auto`} />
            </Grid>
            <Grid item xs={4} container direction='column' justify='center'>
              <Grid item container>
                {toggleImage(capture, false, null, `${classes.listImg} ${hovered ? classes.hoveredImage : ''}`, { onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), onClick: handleClick })}
              </Grid>
              {capture.quarantined && <QuarantineSubBanner redacted={capture.redacted} height={70} fontSize={14} />}
            </Grid>
            <Grid item xs={6} container direction='row' className={classes.infoContainer}>
              <CardContent className='w-100'>
                <List disablePadding className='my-auto'>
                  <ListItem>
                    <Grid container direction='row' spacing={2} className='w-100 mx-auto'>
                      <Grid item container direction='row' alignItems='center'>
                        <Grid item>
                          <Typography variant='h6' className='font-weight-bold'>Username: </Typography>
                        </Grid>

                        <Grid item>
                          <Button
                            variant='text'
                            color='primary'
                            onClick={() => { handleQuickFilter({ username: capture.username }) }}
                          >
                            {capture.userDisplayName || capture.username || 'N/A'}
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </ListItem>

                  <ListItem>
                    <Grid container direction='row' spacing={2} className='w-100 mx-auto'>
                      <Grid item xs={6} container direction='row' alignItems='center'>
                        <Grid item>
                          <Typography variant='h6' className='font-weight-bold'>Category: </Typography>
                        </Grid>

                        <Grid item>
                          <Button
                            variant='outlined'
                            color='primary'
                            onClick={(e) => { e.preventDefault(); handleQuickFilter({ categoryName: capture.categoryName }) }}
                          >
                            {capture.categoryName || 'N/A'}
                          </Button>
                        </Grid>
                      </Grid>

                      <Grid item xs={6} container direction='row' alignItems='center'>
                        <Grid item>
                          <Typography variant='h6' className='font-weight-bold'>Phrase: </Typography>
                        </Grid>

                        <Grid item>
                          <Button
                            variant='outlined'
                            color='primary'
                            onClick={() => { handleQuickFilter({ phrase: capture.phrase }) }}
                          >
                            {capture.multiple_phrases ? `${capture.phrase} *` : capture.phrase || 'N/A'}
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </ListItem>

                  <ListItem>
                    <Grid container direction='row' spacing={2} className='w-100 mx-auto'>
                      <Grid item xs={6} container direction='row' alignItems='center'>
                        <Grid item>
                          <Typography variant='h6' className='font-weight-bold'>Station: </Typography>
                        </Grid>

                        <Grid item>
                          <LightTooltip title={capture.workstationName} placement='right'>
                            <Button
                              variant='text'
                              color='primary'
                              onClick={() => { handleQuickFilter({ workstationName: capture.workstationName }) }}
                            >
                              {truncateText(`${capture.workstationName ? capture.workstationName : 'N/A'}`)}
                            </Button>
                          </LightTooltip>
                        </Grid>
                      </Grid>

                      <Grid item xs={6} container direction='row' alignItems='center'>
                        <Grid item>
                          <Typography variant='h6' className='font-weight-bold'>IP ADDR: </Typography>
                        </Grid>

                        <Grid item>
                          <Typography>{capture.station_ip || '0.0.0.0'}</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </ListItem>

                  <ListItem>
                    <Grid container direction='row' spacing={2} className='w-100 mx-auto'>
                      <Grid item xs={6} container direction='row' alignItems='center'>
                        <Grid item>
                          <Typography variant='h6' className='font-weight-bold'>Source: </Typography>
                        </Grid>
                        <Grid item>
                          {SourceIcon(getSourceDescription(capture.source), handleQuickFilter, iconOptions, 50)}
                        </Grid>
                      </Grid>

                      <Grid item xs={6} container direction='row' alignItems='center'>
                        <Grid item>
                          <Typography variant='h6' className='font-weight-bold'>Application: </Typography>
                        </Grid>
                        <Grid item>
                          <LightTooltip title={capture.applicationName} placement='right'>
                            <Button
                              color='primary'
                              variant='text'
                              onClick={(e) => { handleQuickFilter({ applicationName: capture.applicationName }) }}
                            >
                              {truncateText((`${capture.applicationName ? capture.applicationName : 'N/A'}`))}
                            </Button>
                          </LightTooltip>
                        </Grid>
                      </Grid>
                    </Grid>
                  </ListItem>
                </List>
              </CardContent>
            </Grid>
            <Grid item xs={2} className='severityBanner'>
              <Paper id='severity-badge-list' elevation={1} color='primary' style={{ backgroundColor: getSeverityColor(capture.severity), color: '#FFFFFF' }}>{capture.severity}</Paper>
              <Grid item style={{ justifyContent: 'flex-end', marginTop: '15px' }}>
                <Typography variant='h4' className='violationDate month'>{moment.unix(capture.reportedAt / 1000).format('MMM')}</Typography>
                <Typography variant='h2' className='violationDate'>{moment.unix(capture.reportedAt / 1000).format('DD')}</Typography>
                <Typography variant='h4' className='violationDate time'>{moment.unix(capture.reportedAt / 1000).format('YYYY')}</Typography>
                <Typography variant='h4' className='violationDate time'>{moment.unix(capture.reportedAt / 1000).format('LT')}</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Card>}
    </>
  )
}

export default withRouter(ListView)
